import React, { useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useSelector } from "react-redux";
import {
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaClock,
  FaWhatsapp,
  FaDirections,
  FaCheckCircle,
  FaCalendarAlt,
} from "react-icons/fa";

const ContactUs = () => {
  const hotel = useSelector((state) => state.hotel.data);
  const hotelName = hotel?.name || "Ganesh Holiday Homes";

  const contact = hotel?.contact || {
    phone: "+91 9673150591",
    altPhone: "+91 9028139260",
    email: "ganeshholidayhomes@gmail.com",
    address: "Narayan Pakhadi Rd, Narayan Pakhadi, Shrivardhan-402110, Maharashtra, India",
    website: "https://ganeshholidayhomes.com",
  };

  const cleanPhone = (contact.phone || "+91 9673150591").replace(/[^0-9]/g, "");

  const [inquiryData, setInquiryData] = useState({
    name: "",
    phone: "",
    message: "",
  });
  const [submitted, setSubmitted] = useState(false);

  const handleInquirySubmit = (e) => {
    e.preventDefault();
    const msg = `Hi Ganesh Holiday Homes! My name is ${inquiryData.name} (${inquiryData.phone}). Inquiry: ${inquiryData.message}`;
    const waUrl = `https://wa.me/${cleanPhone}?text=${encodeURIComponent(msg)}`;
    window.open(waUrl, "_blank");
    setSubmitted(true);
  };

  return (
    <div className="d-flex flex-column min-vh-100 bg-light">
      <Navbar />

      {/* Hero Banner */}
      <div
        style={{
          background: "linear-gradient(135deg, #07101e 0%, #0b192c 50%, #1e3e62 100%)",
          color: "#ffffff",
          padding: "50px 0 60px 0",
          borderBottom: "1px solid rgba(255, 255, 255, 0.08)",
        }}
      >
        <div className="container text-center">
          <div className="d-inline-flex align-items-center gap-2 bg-white bg-opacity-10 text-white px-3 py-1 rounded-pill small fw-semibold mb-3 border border-white border-opacity-15">
            <span>📍 Shrivardhan Beach, Maharashtra • 5 Min Walk</span>
          </div>
          <h1 className="h1 fw-bold mb-2 font-heading text-white" style={{ fontSize: "2.5rem" }}>
            Contact & Location Details
          </h1>
          <p className="text-white-50 mb-0 mx-auto" style={{ maxWidth: "700px", fontSize: "1.05rem" }}>
            Get in touch with the front desk of {hotelName} for room booking inquiries, travel directions, and assistance.
          </p>
        </div>
      </div>

      {/* Main Content */}
      <main className="container flex-grow-1 py-5">
        <div className="row g-4">
          {/* Left Column: Official Contact & Address Details */}
          <div className="col-12 col-lg-5">
            <div className="p-4 p-md-5 rounded-4 shadow-sm bg-white border h-100 d-flex flex-column">
              <h2 className="h4 fw-bold text-dark mb-4 font-heading">Official Property Information</h2>

              <div className="d-flex align-items-start gap-3 mb-4">
                <div className="bg-danger bg-opacity-10 text-danger p-3 rounded-circle fs-5 flex-shrink-0">
                  <FaMapMarkerAlt />
                </div>
                <div>
                  <strong className="d-block text-dark mb-1">Physical Property Address</strong>
                  <p className="text-secondary small mb-1">
                    <strong>{hotelName}</strong>
                  </p>
                  <p className="text-secondary small mb-0">
                    Narayan Pakhadi Rd, Narayan Pakhadi,<br />
                    Shrivardhan – 402110,<br />
                    Raigad District, Maharashtra, India
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start gap-3 mb-4">
                <div className="bg-success bg-opacity-10 text-success p-3 rounded-circle fs-5 flex-shrink-0">
                  <FaPhoneAlt />
                </div>
                <div>
                  <strong className="d-block text-dark mb-1">Front Desk Phone & Mobile</strong>
                  <p className="text-secondary small mb-1">
                    Primary: <a href={`tel:${cleanPhone}`} className="text-decoration-none text-dark fw-bold">{contact.phone}</a>
                  </p>
                  {contact.altPhone && (
                    <p className="text-secondary small mb-0">
                      Alternate: <a href={`tel:${contact.altPhone.replace(/[^0-9]/g, "")}`} className="text-decoration-none text-dark">{contact.altPhone}</a>
                    </p>
                  )}
                </div>
              </div>

              <div className="d-flex align-items-start gap-3 mb-4">
                <div className="bg-primary bg-opacity-10 text-primary p-3 rounded-circle fs-5 flex-shrink-0">
                  <FaEnvelope />
                </div>
                <div>
                  <strong className="d-block text-dark mb-1">Customer Support Email</strong>
                  <p className="text-secondary small mb-0">
                    <a href={`mailto:${contact.email}`} className="text-decoration-none text-danger fw-semibold">
                      {contact.email}
                    </a>
                  </p>
                </div>
              </div>

              <div className="d-flex align-items-start gap-3 mb-4">
                <div className="bg-warning bg-opacity-10 text-warning p-3 rounded-circle fs-5 flex-shrink-0 text-dark">
                  <FaClock />
                </div>
                <div>
                  <strong className="d-block text-dark mb-1">Front Desk Hours & Timings</strong>
                  <p className="text-secondary small mb-1">
                    <strong>Front Desk Hours:</strong> 7:00 AM – 10:00 PM (Daily)
                  </p>
                  <p className="text-secondary small mb-0">
                    <strong>Check-in:</strong> After 12:00 PM | <strong>Check-out:</strong> Before 11:00 AM
                  </p>
                </div>
              </div>

              <div className="pt-4 border-top mt-auto d-flex flex-column gap-2">
                <a
                  href={`https://wa.me/${cleanPhone}?text=Hello%20Ganesh%20Holiday%20Homes,%20I%20have%20a%20query%20about%20room%20booking`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-success rounded-pill fw-semibold py-2 d-flex align-items-center justify-content-center gap-2 shadow-sm"
                >
                  <FaWhatsapp className="fs-5" /> Chat with Host on WhatsApp
                </a>
                <Link
                  to="/booking"
                  className="btn btn-danger rounded-pill fw-semibold py-2 shadow-sm d-flex align-items-center justify-content-center gap-2"
                >
                  <FaCalendarAlt /> Reserve a Room Online
                </Link>
              </div>
            </div>
          </div>

          {/* Right Column: Interactive Map & Inquiry Form */}
          <div className="col-12 col-lg-7 d-flex flex-column gap-4">
            {/* Map Card */}
            <div className="p-4 p-md-5 rounded-4 shadow-sm bg-white border">
              <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
                <h3 className="h5 fw-bold text-dark mb-0 font-heading">Location & Beach Proximity</h3>
                <a
                  href="https://maps.google.com/?q=Ganesh+Holiday+Homes+Shrivardhan"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn btn-sm btn-outline-danger rounded-pill px-3 fw-semibold d-flex align-items-center gap-1"
                >
                  <FaDirections /> Open in Google Maps
                </a>
              </div>
              <p className="text-secondary small mb-3">
                Located on Narayan Pakhadi Rd, just 500 meters (5-minute walk) from Shrivardhan Beach with safe gated parking.
              </p>

              <div className="ratio ratio-16x9 rounded-3 overflow-hidden border shadow-sm">
                <iframe
                  src={
                    hotel.mapEmbedUrl ||
                    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3793.509772394372!2d73.0144725!3d18.0479406!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be84b0050e3104d%3A0x3d82494704c6c280!2sGanesh%20Holiday%20Homes!5e0!3m2!1sen!2sin!4v1758918689794!5m2!1sen!2sin"
                  }
                  title="Ganesh Holiday Homes Location Map"
                  loading="lazy"
                  style={{ border: 0 }}
                />
              </div>
            </div>

            {/* Quick Inquiry Form */}
            <div className="p-4 p-md-5 rounded-4 shadow-sm bg-white border">
              <h3 className="h5 fw-bold text-dark mb-2 font-heading">Send a Booking Inquiry</h3>
              <p className="text-secondary small mb-4">
                Have questions regarding availability, group bookings, or home-style meal preferences? Fill out this quick form.
              </p>

              {submitted ? (
                <div className="alert alert-success d-flex align-items-center gap-2 rounded-3">
                  <FaCheckCircle className="fs-5 flex-shrink-0" />
                  <span>Thank you! Your inquiry was forwarded to our front desk team. We will get back to you immediately.</span>
                </div>
              ) : (
                <form onSubmit={handleInquirySubmit}>
                  <div className="row g-3">
                    <div className="col-12 col-sm-6">
                      <label className="form-label small fw-semibold text-secondary">Your Full Name *</label>
                      <input
                        type="text"
                        className="form-control rounded-3"
                        required
                        placeholder="e.g. Rahul Sharma"
                        value={inquiryData.name}
                        onChange={(e) => setInquiryData({ ...inquiryData, name: e.target.value })}
                      />
                    </div>
                    <div className="col-12 col-sm-6">
                      <label className="form-label small fw-semibold text-secondary">Mobile Number *</label>
                      <input
                        type="tel"
                        className="form-control rounded-3"
                        required
                        placeholder="10-digit mobile number"
                        value={inquiryData.phone}
                        onChange={(e) => setInquiryData({ ...inquiryData, phone: e.target.value })}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label small fw-semibold text-secondary">Message / Desired Dates *</label>
                      <textarea
                        className="form-control rounded-3"
                        rows="3"
                        required
                        placeholder="Tell us your desired stay dates, number of guests, or meal requests..."
                        value={inquiryData.message}
                        onChange={(e) => setInquiryData({ ...inquiryData, message: e.target.value })}
                      ></textarea>
                    </div>
                    <div className="col-12">
                      <button type="submit" className="btn btn-danger rounded-pill px-4 py-2 fw-semibold shadow-sm">
                        Submit Inquiry via WhatsApp
                      </button>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default ContactUs;
